<template>
  <div class="cf-wrapper" @scroll="onScrollLeft()">
    <template>
      <cf-header
        :clientName="clientName"
        :partnerName="partnerName"
      ></cf-header>
      <div class="cf-routeHolder">
        <div class="container">
          <div class="cf-bodyWrapper padding-tb-24">
            <router-view></router-view>
            <div
              v-if="isShowLoader || !isShowClientInformation"
              class="mds-loader-WrapCustom"
            >
              <mds-loader size="medium"></mds-loader>
            </div>
          </div>
        </div>
      </div>
      <mds-notification-container>
        <mds-notification
          v-if="notificationSummary.isShow"
          :class="$style['mds-notification__variation']"
          :key="key"
          :variation="notificationSummary.variation"
          @mds-notification-dismissed="removeNotification()"
        >
          {{ notificationSummary.text }}
        </mds-notification>
      </mds-notification-container>
    </template>
  </div>
</template>
<script>
import { CfHeader } from "../component";
import MdsLoader from "@mds/loader";
import { mapActions, mapGetters } from "vuex";
import UserEvent from "../services/userEvent";
import { MdsNotification, MdsNotificationContainer } from "@mds/notification";
import CryptoJS from "crypto-js";

import {
  SET_AUTH_INFORMATION,
  GET_AUTH_INFORMATION,
  GET_LOADER_VISIBILITY,
  SET_CLIENT_INFORMATION,
  GET_CLIENT_INFORMATION,
  SET_CLIENT_Session,
  SET_JWT_AUTH_INFORMATION,
  GET_NOTIFICATION_SUMMARY,
  SET_LOADER_VISIBILITY,
} from "../helpers/vuex-constants";

import { AuthService } from "../services";
export default {
  name: "cash-flow",
  components: {
    CfHeader,
    MdsLoader,
    MdsNotification,
    MdsNotificationContainer,
  },
  data() {
    return {
      isShowClientInformation: false,
      loading: false,
      authDetails: {
        key: "",
        clientId: "",
        adviserId: "",
        companyId: "",
      },
      clientName: "",
      partnerName: "",
    };
  },
  async created() {
    this.getUrlParams();
    await this.setAuthParams();
    await this.getclientdata(this.getAuthInformation.clientId);
    try{
    window.dataLayer.push({event: "userData", 'user_id': this.getAuthInformation.clientId })
    }
    catch{
      console.log('exception')
    }
    this.isShowClientInformation = true;
    this.clientName = this.getClientInformation.filter((item) => {
      return item.entityType == 1;
    })[0].clientName;
    if (
      this.getClientInformation.filter((item) => {
        return item.entityType == 2;
      }).length > 0
    ) {
      this.partnerName = this.getClientInformation.filter((item) => {
        return item.entityType == 2;
      })[0].clientName;
    }
  },
  mounted() {
    this.setLoaderVisibility(true);
  },
  computed: {
    key() {
      return this.notificationSummary.variation + "-default";
    },
    ...mapGetters({
      getAuthInformation: GET_AUTH_INFORMATION,
      isShowLoader: GET_LOADER_VISIBILITY,
      getClientInformation: GET_CLIENT_INFORMATION,
      notificationSummary: GET_NOTIFICATION_SUMMARY,
    }),
  },

  methods: {
    ...mapActions({
      setAuthInformation: SET_AUTH_INFORMATION,
      setClientInformation: SET_CLIENT_INFORMATION,
      setClientSession: SET_CLIENT_Session,
      setJWTAuthInformation: SET_JWT_AUTH_INFORMATION,
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    onScrollLeft() {
      let elements = document.getElementsByClassName("mds-popover_CashFlow");
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.display = "none";
      }
    },
    removeNotification() {
      this.notificationSummary.isShow = false;
    },
    async getclientdata(clientid) {
      await this.setClientInformation(clientid);
    },
    async getAuthCode(queryString) {
      let code_verfier = crypto["randomUUID"]();
      this.setClientSession(code_verfier);
      let code_Verifier_hash = CryptoJS.SHA256(code_verfier).toString(
        CryptoJS.enc.Base64
      );
      let code_challenge = encodeURIComponent(code_Verifier_hash);
      let authCode = await AuthService.getAuthCodeWithChallange(code_challenge);
      let jwtData = await AuthService.getTokenWithVerifier(
        authCode.data.code,
        this.getClaim(queryString),
        code_verfier
      );
      this.setLoaderVisibility(false);
      await this.callResetRefreshToken(jwtData);
      this.saveUserEvent(queryString);
    },
    async callResetRefreshToken(jwtData) {
      this.authDetails.wrapCode = "Bearer " + jwtData.data.access_token;
      await this.setJWTAuthInformation(this.authDetails);
      this.resetRefreshClaim(jwtData.data);
    },
    resetRefreshClaim(refToken) {
      if (refToken.access_token) {
        var tokenExpTime = new Date(
          new Date(refToken.expires_at).setMinutes(
            new Date(refToken.expires_at).getMinutes() - 3
          )
        ).getTime();
        var currentTime = new Date().getTime();
        let refreshTokenCallTime = tokenExpTime - currentTime;

        setTimeout(async () => {
          let jwtData = await AuthService.getRefreshToken(
            refToken.refresh_token
          );
          this.callResetRefreshToken(jwtData);
        }, refreshTokenCallTime);
      }
    },

    getClaim(queryString) {
      let userdetails = this.getUserDetailsFromQueryString(queryString);
      let claims = {
        encClientId: userdetails.encClientId,
        encAdviserId: userdetails.encAdviserId,
        encCompanyId: userdetails.encCompanyId,
        sessionId: crypto["randomUUID"](),
      };

      return claims;
    },
    saveUserEvent(queryString) {
      let userdetails = this.getUserDetailsFromQueryString(queryString);

      let payload = {
        AdviserId: userdetails.encAdviserId,
        ClientId: userdetails.encClientId,
        EventId: 1,
      };
      UserEvent.save(payload);
    },
    getUserDetailsFromQueryString(queryString) {
      let obj = {
        encClientId: "",
        encAdviserId: "",
        encCompanyId: "",
      };
      var paramsQuery = queryString.split("&");
      for (let i = 0; i < paramsQuery.length; i++) {
        var arrsplit = paramsQuery[i].split("|=|");
        switch (arrsplit[0]) {
          case "encCompanyId":
            obj.encCompanyId = arrsplit[1];
            break;
          case "encAdviserId":
            obj.encAdviserId = arrsplit[1];
            break;
          case "ClientID":
            obj.encClientId = arrsplit[1];
            break;
        }
      }
      return obj;
    },
    getUrlParams() {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      this.authDetails.key = params.get("Key");
      this.authDetails.clientId = params.get("clid");
      this.authDetails.adviserId = params.get("aid");
      this.authDetails.companyId = params.get("cid");
      this.authDetails.QueryString = params.get("QueryString");
    },
    async setAuthParams() {
      if (!this.authDetails.QueryString) {
        await this.setAuthInformation(this.authDetails);
      } else {
        // await this.setJWTAuthInformation(this.authDetails);
        await this.getAuthCode(this.authDetails.QueryString);
      }
    },
    onBack() {
      this.$router.back();
    },
  },
};
</script>
<style lang="scss" module>
.mds-notification__variation {
  background-color: #fff !important;
}
</style>
